import { render, staticRenderFns } from "./LabClientOrganisation.vue?vue&type=template&id=ab81029c"
import script from "./LabClientOrganisation.vue?vue&type=script&lang=js"
export * from "./LabClientOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports